import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/settings/company_vendors/Page";

export const PATH = "/settings/company_vendors";

function Home() {
	return (
		<>
			<NskHead title="施工会社一覧" />
			<Component />
		</>
	);
}

export default Home;
